import { Box, Button, Flex, Grid, Image, styled } from '@grupoboticario/flora-react';

export const styles = {
  Flex: styled(Flex, {
    paddingBottom: '$8',
  }),
  CarouselWrapper: styled(Box, {
    '.slick-track': {
      display: 'flex',
      gap: '$4',
    },
  }),

  WithoutCarouselWrapper: styled(Grid, {
    gap: '$4',
    width: '100%',

    '@tablet': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($22 * 3), 1fr))',
    },
  }),

  Image: styled(Image, {
    borderRadius: '$small',
    overflow: 'hidden',

    '&[data-isolated]': {
      '@desktop': {
        maxWidth: 'calc(100% / 4 - $4)',
      },
    },
  }),

  TitleWrapper: styled(Flex, {
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '$6',

    '@tablet': {
      justifyContent: 'flex-start',
    },
  }),

  LastItemImage: styled(Image, {
    objectFit: 'contain',
    objectPosition: 'center',
    opacity: '0.2',
    padding: '0 $2',
    position: 'relative',
    zIndex: '-1',
  }),

  LastItemButton: styled(Button, {
    position: 'absolute',
  }),
};

export default styles;
